import { useEffect, useState } from 'react'
import type { JSX } from 'react'
import { useTranslation } from 'react-i18next'
import { Card, PageHeader } from '@rs/ui'
import { loadKeyGroups, tDynamic } from '@rs/ui/i18n'
import { RtNotices } from '../features/az/RtNotices.tsx'
import { OpenOrdersStrip } from '../features/az/OpenOrdersStrip.tsx'

/**
 * ══ THẺ 🔒 KHÔNG CÓ QUYỀN — thay cho việc lặng lẽ đá về trang chủ (pham-vi-10, rà 21/10) ══════════════════════════
 * Bản cũ KHÔNG chặn ba đường dẫn này ở `routeAccess.ts` (`:29-45`) mà mở trang rồi vẽ thẻ 🔒 nói rõ vì sao và xin ai:
 *  · `/az/purchase-docs` · `/az/vendor-pnl` — "Bạn không có quyền xem giá thầu phụ" + chỉ cách xin tick (`Az.tsx:670-680`).
 *  · `/az/ops-catalog` — "Bạn không có quyền xem Danh mục vận hành" + danh sách vai (`Az.tsx:21412-21419`).
 * Sale bấm link Chứng từ MH, điều hành bấm chuông Danh mục vận hành: thấy thẻ này thay vì nhảy về Đơn hàng không lời giải thích.
 * ⚠ Chỉ là lối đi cho người dùng — MÁY CHỦ vẫn 403 mọi cửa dữ liệu của ba màn này.
 */
export const RouteLockCard = ({ kind, path }: { kind: 'cost' | 'opsCatalog'; path?: string | undefined }): JSX.Element => {
  const { t } = useTranslation()
  const [ready, setReady] = useState(false)
  useEffect(() => {
    let alive = true
    void loadKeyGroups('az', 'nav').then(() => { if (alive) setReady(true) })
    return () => { alive = false }
  }, [])
  if (!ready) return <p>{t('common.loading')}</p>
  if (kind === 'opsCatalog') {
    return (
      <Card className="p-10 text-center">
        <div className="text-3xl mb-2">🔒</div>
        <div className="text-sm font-bold text-slate-700">{t('az.opscat.noAccessTitle')}</div>
        <div className="text-[12px] text-slate-500 mt-1">
          {t('az.opscat.noAccessPre')} <b>{t('az.opscat.noAccessRoles')}</b> {t('az.opscat.noAccessPost')}
        </div>
      </Card>
    )
  }
  /* ⭐ THẺ NẰM TRONG KHUNG TRANG RT (R0232): bản cũ vẽ thẻ trong `AzPage` (`Az.tsx:670`) nên phía trên vẫn có tiêu đề "LOGISTICS RT ·
     Chứng từ MH / Hiệu quả NCC", dòng mô tả, các dòng báo (cần danh mục · 👤 "chỉ xem N đơn") và — riêng Hiệu quả NCC — dải "Đơn
     đang mở" (`Az.tsx:593-631`, R0221). Trước 23/10 chỉ còn một thẻ khoá trơ trọi. */
  const titleKey = path === '/az/vendor-pnl' ? 'nav.azVendorPnl' : 'nav.azPurchaseDocs'
  const card = (
    <Card className="p-8 text-center">
      <div className="text-3xl mb-2">🔒</div>
      <div className="font-bold text-slate-700">{t('az.costLock.title')}</div>
      <p className="text-[12px] text-slate-500 mt-1 max-w-md mx-auto">
        {t('az.costLock.body')}
      </p>
    </Card>
  )
  if (path === undefined) return card
  return (
    <section className="space-y-4">
      <PageHeader title={tDynamic(t, titleKey)} />
      <RtNotices />
      {path === '/az/vendor-pnl' && <OpenOrdersStrip />}
      {card}
    </section>
  )
}
